<section class="jalasoft-foundation-section">
  <div class="content">
    <p class="title">Fundación Jala</p>
    <div class="description" #animation>
      <p>
        Nace con el objetivo de crear talento tecnológico para la región.
        Trabajamos constantemente en renovar nuestros programas de capacitación
        para responder a las necesidades actuales de la Industria del Software.
      </p>
      <p>
        Durante estos 10 años llegamos a tener más de 1023 becarios graduados.
        Trabajamos en:
      </p>
      <p>
        - Mejorar la calidad de la formación de ingenieros de software
        llevándolos a un nivel internacional.
      </p>
      <p>
        - Formar de manera práctica, para brindarle al estudiante su primera
        experiencia real de trabajo.
      </p>
      <p>
        - Capacitar de manera gratuita y remota, junto a los mejores trainers de
        la industria.
      </p>
    </div>
  </div>
</section>
